import React from "react";
import HttpsRedirection from "react-https-redirect";

const HttpsRedirect = ({ children }) => {
  const isRedirectToHTTPS = process.env.NODE_ENV || false;

  return isRedirectToHTTPS && isRedirectToHTTPS !== "development" ? (
    <HttpsRedirection>{children}</HttpsRedirection>
  ) : (
    children
  );
};

export default HttpsRedirect;
